import script from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=742473b3&lang=css"

const __exports__ = script;

export default __exports__